import React, { useState } from "react";
import axios from "axios";
import styles from "./Popup.module.css";
import { Link } from "react-router-dom";

const Popup = ({ isOpen, onClose, ebookData, onDownload }) => {
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [nameError, setNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const marketingBackendUrl = import.meta.env.VITE_MARKETING_BACKEND_URL;

  if (!isOpen || !ebookData) return null;

  const handleDownload = async () => {
    let isValid = true;

    // Validate full name
    if (!fullName.trim()) {
      setNameError("Full name is required.");
      isValid = false;
    } else {
      setNameError("");
    }

    // Validate email
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email.trim()) {
      setEmailError("Email is required.");
      isValid = false;
    } else if (!emailPattern.test(email)) {
      setEmailError("Please enter a valid email address.");
      isValid = false;
    } else {
      setEmailError("");
    }

    if (isValid) {
      try {
        // Modify the request to hit the create-download request endpoint
        const response = await axios.post(
          `${marketingBackendUrl}/maflam/create-ebook-request`,
          {
            ebookName: ebookData.title,
            userFullName: fullName,
            email: email,
          }
        );

        // Show success message using alert
        alert("Your request has been submitted successfully!");

        // Close the popup after success (optional)
        onClose();
      } catch (error) {
        console.error("Error creating download request:", error);
        setEmailError("Failed to create download request. Please try again.");
      }
    }
  };

  return (
    <>
      <div className={styles.overlay} onClick={onClose}></div>
      <div className={styles.popupContainer}>
        <button className={styles.closeButton} onClick={onClose}>
          X
        </button>
        <div className={styles.popupContent}>
          <div className={styles.formContainer}>
            <h2>
              To Get The Ebook Please{" "}
              <Link to="/home/R2/R3/prc/All"> Subscribe</Link> to a Course or
              Request admin.
            </h2>
            <div className={styles.inputGroup}>
              <label htmlFor="fullName">Full Name</label>
              <input
                type="text"
                id="fullName"
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
                placeholder="Enter your full name"
                className={styles.inputField}
              />
              {nameError && <p className={styles.errorText}>{nameError}</p>}
            </div>
            <div className={styles.inputGroup}>
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                className={styles.inputField}
              />
              {emailError && <p className={styles.errorText}>{emailError}</p>}
            </div>
            {/* <button onClick={handleDownload} className={styles.downloadButton}>
              Request
            </button> */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              {/* Download Icon Container */}
              <div
                onClick={handleDownload}
                style={{
                  //   width: "64px",
                  //   height: "64px",
                  backgroundColor: "#061C2B",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "grab",
                }}
              >
                {/* <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M12 3V15M12 15L8 11M12 15L16 11"
                    stroke="#39FFFB"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M5 19H19"
                    stroke="#39FFFB"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg> */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="64"
                  height="65"
                  viewBox="0 0 64 65"
                  fill="none"
                >
                  <rect
                    y="0.645996"
                    width="64"
                    height="64"
                    rx="32"
                    fill="#39FFFB"
                  />
                  <path
                    d="M44.5729 35.71C43.9281 35.71 43.4321 36.206 43.4321 36.8508V41.4139C43.4321 42.0587 42.9361 42.5547 42.2914 42.5547H21.7075C21.0627 42.5547 20.5667 42.0587 20.5667 41.4139V36.8508C20.5667 36.206 20.0707 35.71 19.4259 35.71C18.7812 35.71 18.2852 36.206 18.2852 36.8508V41.4139C18.2852 43.2987 19.8227 44.8363 21.7075 44.8363H42.2914C44.1761 44.8363 45.7137 43.2987 45.7137 41.4139V36.8508C45.7137 36.2556 45.2177 35.71 44.5729 35.71Z"
                    fill="#061C2B"
                  />
                  <path
                    d="M24.3368 32.9324L29.5944 38.1899C30.9336 39.5291 33.116 39.5291 34.4552 38.1899L39.7127 32.9324C40.1591 32.486 40.2087 31.7916 39.7623 31.2956C39.3159 30.7996 38.6215 30.7996 38.1255 31.246L38.0759 31.2956L33.1656 36.206V18.5485C33.1656 17.9037 32.6696 17.4077 32.0248 17.4077C31.38 17.4077 30.884 17.9037 30.884 18.5485V36.206L25.9736 31.2956C25.5272 30.8492 24.8328 30.7996 24.3368 31.246C23.8408 31.6924 23.8408 32.4364 24.3368 32.9324C24.2872 32.8828 24.2872 32.8828 24.3368 32.9324Z"
                    fill="#061C2B"
                  />
                </svg>
              </div>

              {/* Download Button Container */}
              <button
                // onClick={handleDownload}
                style={{
                  backgroundColor: "#39FFFB",
                  border: "none",
                  borderRadius: "64px",
                  padding: "24px 32px",
                  fontSize: "17px",
                  fontWeight: "bold",
                  color: "#061C2B",
                  cursor: "pointer",
                  boxShadow: "0px 4px 6px rgba(90, 255, 234, 0.30)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                }}
              >
                Request
              </button>
            </div>
          </div>
          <div className={styles.imageContainer}>
            <img
              src={ebookData.imgSrc}
              alt={ebookData.title}
              className={styles.ebookImage}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Popup;
